export const i18nSupportedLangCodes = ['de', 'en', 'es', 'fr', 'nl', 'bg', 'pt', 'sv', 'zh'];

export const availableLanguages = {
    'de': 'Deutsch',
    'en': 'English',
    'es': 'Español',
    'fr': 'Français',
    'nl': 'Nederlands',
    'bg': 'Български',
    'pt': 'Português',
    'sv': 'Svenska',
    'zh': '中国'
};